import React, { useEffect, useState } from 'react'
import Footer from './components/Footer'
import Hero from './components/Hero'
import MobFootall from './components/MobFootall'
import Header from './components/Header'
import './assets/styles/_md.scss'
import './assets/styles/_sm.scss'
import './assets/styles/_small.scss'
import './assets/styles/_xl.scss'
import './assets/styles/_xs.scss'
import './assets/styles/_lg.scss'
import './assets/styles/style.scss'
import './assets/styles/styles.scss'

import Pagelog from './components/PageLog'
import HelmetTags from './components/seo/HelmetTags'
import axios from 'axios'

const Main = () => {

  const [called, setCalled] = useState(false)

  const [business, setbusiness] = useState({})

  const getBusiness = async () => {
    if (!called)
      await axios({
        method: 'post',
        baseURL: 'https://coreapi.bimeh.com',
        url: '/Front/business-by-url',
        timeout: 30000,
        headers: {
          'Content-Type': 'application/json'
        },
        data: { url: 'bimeh.com' }
      }).then(response => {
        setCalled(true)
        setbusiness(response.data)
        const state = JSON.parse(localStorage?.getItem('app-store'))?.state;
        localStorage.setItem('app-store', JSON.stringify({ state: { ...state, business: response.data } }))
      })
  }

  useEffect(() => {
    getBusiness()
  }, [])

  return (
    <div className='main-page'>
      <HelmetTags business={business} />
      <Pagelog />
      {<Header business={business} />}
      <Hero />
      <MobFootall type={0} />
      <MobFootall type={1} />
      <Footer business={business} />
    </div>
  )
}

export default Main
